<template>
    <div class="carBox" @mouseup="handleMouseUp">
        <el-card ref="left_tree" class="box-card treeBox" style="height: calc(100vh - 152px);width: 300px;overflow-y: auto">
            <el-tree :data="projectDivisionData" node-key="value" :current-node-key="pid" :highlight-current="true" ref="my-tree" @node-click="clickPrjectDivision" :default-expanded-keys="openKeys" :expand-on-click-node="false">
                <span slot-scope="{ node }" class="custom-tree-node treeTitle" :title="node.label.split('###')[3]">
                    <!-- <span class="treeTitleNum3" style="margin-left: 0" v-if="node.label.split('###')[3]=='X'">{{node.label.split('###')[0]}}</span>
                    <span v-else>{{node.label.split('###')[0]}}</span> -->
                    {{node.label.split('###')[0]}}
                    <span :class="'treeTitleNum'+node.label.split('###')[1]">{{node.label.split('###')[2]}}</span>
                </span>
            </el-tree>
        </el-card>
        <div ref="resizeHandle" class="handle-resize" />
        <div ref="moveDiv" class="handle-resize-h" />
        <div class="newBox" style="width: calc(100% - 340px)">
        <div class="searchBox" v-if="list_model ==1">

            <div class="searchGroup">
                <label>孔号：</label>
                <el-input v-model="search_Obj.f_hole_code" clearable @keyup.enter.native="doSearch"></el-input>
            </div>
            <div class="searchGroup">
                <label>数据筛选：</label>
                <el-select v-model="search_Obj.is_error" clearable placeholder="请选择" @keyup.enter.native="doSearch">
                    <el-option label="包含异常数据" value="1"></el-option>
                </el-select>
            </div>
            <el-button type="primary" size="medium" icon="el-icon-search" @click.native="doSearch">搜索</el-button>
        </div>
    <el-card class="box-card">
        <div class="mainBody">
        <div class="btnBox">
            <Btns :menu_id="menu_id" :menus="main_btns" @on_btnclk="btnClick" v-if="grade==4"></Btns>
                                <Btns :menu_id="menu_id" :menus="main_btns" @on_btnclk="btnClick" :ignore_ids="',7302,7304,'" v-if="grade>0 && grade<4"></Btns>
        </div>
            <div class="dataBox" v-if="list_model ==1">
                                <el-table :data="pagedData" :default-sort="sortData" :empty-text="empty_text" v-loading="loading" @sort-change="sortTable" border stripe>
                                    <el-table-column prop="hole_code" label="孔号" sortable width="120"></el-table-column>
                                    <el-table-column prop="grout_volume" label="注浆量(L)"></el-table-column>
                                    <el-table-column prop="grout_volume1" label="监测注浆量(L)"></el-table-column>
                                    <el-table-column prop="grout_volume_cha" label="差异值(L)"></el-table-column>
                                    <el-table-column prop="ash_volume" label="注灰量(Kg)"></el-table-column>
                                    <el-table-column prop="ash_volume1" label="监测注灰量(Kg)"></el-table-column>
                                    <el-table-column prop="ash_volume_cha" label="差异值(Kg)"></el-table-column>
                                    <el-table-column prop="permeable_rate" label="透水率(Lu)"></el-table-column>
                                    <el-table-column prop="permeable_rate1" label="监测透水率(Lu)"></el-table-column>
                                    <el-table-column prop="permeable_rate_cha" label="差异值(Lu)"></el-table-column>
                                    <el-table-column prop="pressure_cha_max" label="压力最大差值(Mpa)"></el-table-column>
                                    <el-table-column prop="pressure_cha_min" label="压力最小差值(Mpa)"></el-table-column>
                                    <el-table-column prop="density_cha_max" label="密度最大差值(g/cm3)"></el-table-column>
                                    <el-table-column prop="density_cha_min" label="密度最小差值(g/cm3)"></el-table-column>
                                    <!-- <el-table-column prop="remark" label="提示"></el-table-column> -->
                                    <!-- <el-table-column prop="un_deal" label="未处置数量" sortable></el-table-column> -->
                                    <el-table-column prop="report_err" label="异常报告数量"></el-table-column>
                                    <el-table-column label="操作" width="120" align="center">
                                        <template slot-scope="scope">
                                            <LabBtns :menu_id="menu_id" :row="scope.row" :index="scope.$index" :menus="lab_btns" @on_btnclk="labelClick"></LabBtns>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </div>
            <div class="pageBox" v-if="list_model ==1">
                                <el-pagination background layout="total, prev, pager, next" :current-page="currentPage" :page-size="pageSize" :total="total" @current-change="handleCurrentChange"></el-pagination>
                            </div>
            <div class="titleBoxwhr" v-if="list_model ==2">
                                <h3>
                                    孔号：{{work_hole.hole_code}}
                                </h3>
                                <el-button style="margin-left: 50px" @click="back()">返回</el-button>
                            </div>
                            <div class="dataBox" v-if="list_model ==2">
                                <el-table :data="tableData1" v-loading="loading" border stripe>
                                    <!-- <el-table-column prop="hole_code" label="孔号"></el-table-column> -->
                                    <el-table-column prop="segment_no" label="段号"></el-table-column>
                                    <el-table-column prop="segment_length" label="灌浆长度"></el-table-column>
                                    <el-table-column prop="grout_volume" label="注浆量(L)"></el-table-column>
                                    <el-table-column prop="grout_volume1" label="监测注浆量(L)"></el-table-column>
                                    <el-table-column prop="grout_volume_cha" label="差异值(L)"></el-table-column>
                                    <el-table-column prop="ash_volume" label="注灰量(kg)"></el-table-column>
                                    <el-table-column prop="ash_volume1" label="监测注灰量(kg)"></el-table-column>
                                    <el-table-column prop="ash_volume_cha" label="差异值(kg)"></el-table-column>
                                    <el-table-column prop="permeable_rate" label="透水率(Lu)"></el-table-column>
                                    <el-table-column prop="permeable_rate1" label="监测透水率(Lu)"></el-table-column>
                                    <el-table-column prop="permeable_rate_cha" label="差异值(Lu)"></el-table-column>
                                    <el-table-column prop="pressure_cha_max" label="压力最大差值(Mpa)"></el-table-column>
                                    <el-table-column prop="pressure_cha_min" label="压力最小差值(Mpa)"></el-table-column>
                                    <el-table-column prop="density_cha_max" label="密度最大差值(g/cm3)"></el-table-column>
                                    <el-table-column prop="density_cha_min" label="密度最小差值(g/cm3)"></el-table-column>
                                    <el-table-column prop="remark1" label="提示"></el-table-column>
                                    <el-table-column prop="result" label="处置结果">
                                        <template slot-scope="scope">
                                            <span>数据正常：{{scope.row.report_count_ok}}<br></span>
                                            <span v-if="scope.row.report_count_err>0" style="color: #F56C6C">数据异常：{{scope.row.report_count_err}}<br></span>
                                            <span v-else>数据异常：{{scope.row.report_count_err}}<br></span>
                                            <!-- <span>数据丢失：{{scope.row.report_count_loss}}<br></span>
                                            <span v-if="scope.row.report_count_no_deal>0" style="color: #F56C6C">数据未处置：{{scope.row.report_count_no_deal}}</span>
                                            <span v-else>数据未处置：{{scope.row.report_count_no_deal}}</span> -->
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="操作" width="100" align="center">
                                        <template slot-scope="scope">
                                            <el-button  size="mini" plain type="primary" @click="info1(scope.row)">查看</el-button>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </div>
        </div>
    </el-card>
</div>
        <Info
            :hole_id="hole_id"
            :segment_no="segment_no"
            :report_type="search_Obj.report_type"
            title="抽检数据验证分析详情"
            :isshow="infoshow"
            @on-close="closeInfoDialog"
            @on-save-ok="verifyOk">
        </Info>
        <el-dialog title="选择时间区间" :visible.sync="export_show" width="500px">
            <el-radio-group v-model="export_time_type">
                <el-radio :label="0">全部</el-radio>
                <el-radio :label="1">按时间段</el-radio>
            </el-radio-group>
            <el-date-picker v-model="dateRange" type="daterange" value-format="yyyy-MM-dd" unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :picker-options="pickerOptions"
                @change="dateRangeSet"
                style="width:320px;margin-top: 20px"
                v-if="export_time_type==1">
            </el-date-picker>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="doExport">确 定</el-button>
                <el-button @click="export_show = false">取 消</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import Btns from "@/components/common/btns"
import LabBtns from "@/components/common/labbtns"
import listutil from "@/libs/listutil"
import { getListData } from '@/api/common'
import { getProjectDivisionTreeData } from '@/api/org'
import { verifyCheck, verifyExportUnit, verifyExportHole, exportVerifyExcel, exportVerifyReportPDFByUnit } from '@/api/statistic'
import Info from "./diffinfo"


export default {
    name: 'verify_diff_check_hole',
    mixins: [listutil],
    components: {Btns, LabBtns, Info},
    data() {
        return {
            m_name: '单孔统计',
            menu_id: 7300,
            list_url: "/api/admin/verify/holeList",
            search_Obj: {
                f_grout_type: '',
                f_hole_code: '',
                is_error: '',
                report_type: 14
            },
            del_Obj:{
                url:'/api/admin/workhole/del',
                data:{
                    ids:''
                }
            },
            enu_name: ['grout_type', 'verify_result'],
            grade: 1,
            pid: 0,
            pname: '',
            projectDivisionData: [],
            openKeys: [],
            sortData: {
                prop: 'un_deal',
                order: 'descending'
            },
            currentPage: 1,
            pageSize: 10,
            pagedData: [],
            export_show: false,
            export_type: 1,
            export_time_type: 0,
            dateRange: '',
            start_date: '',
            end_date: '',
            list_model: 1,
            hole_id: 0,
            segment_no: '',
            tableData1: [],
            empty_text:'',
            work_hole: {},
            echarts_show: 0,
            option: {
                tooltip: {
                    trigger: 'axis'
                },
                legend: {},
                grid: {
                    left: '4%',
                    right: '4%',
                    bottom: '0',
                    containLabel: true
                },
                xAxis: {
                    type: 'category',
                    data: []
                },
                yAxis: {
                    name:'',
                    type: 'value'
                },
                series: [
                    {
                        name: '',
                        type: 'bar',
                        data: []
                    }
                ]
            },
            option1: {
                tooltip: {
                    trigger: 'axis'
                },
                legend: {},
                grid: {
                    left: '4%',
                    right: '4%',
                    bottom: '0',
                    containLabel: true
                },
                xAxis: {
                    type: 'category',
                    data: []
                },
                yAxis: [{
                    name:'',
                    type: 'value'
                },{
                    name:'',
                    type: 'value'
                }],
                series: [
                    {
                        name: '',
                        type: 'bar',
                        yAxisIndex: 0,
                        data: []
                    },
                    {
                        name: '',
                        type: 'bar',
                        yAxisIndex: 1,
                        data: []
                    }
                ]
            },
        };
    },
    mounted(){
        this.dragControllerDiv(this.$refs.left_tree.$el, this.$refs.resizeHandle, this.$refs.moveDiv)
    },
    methods: {
        loadOtherData() {
            this.initTree()
        },
        initTree(){
            this.projectDivisionData = []
            getProjectDivisionTreeData(201).then(res=>{
                if(res.code ==1){
                    var treeData = res.data
                    treeData = this.removeEmptyChild(treeData)
                    this.projectDivisionData = treeData
                    this.initOpenKeys()
                }
            })
        },
        initOpenKeys(){//哪些节点要展开
            this.openKeys = this.getAllNodeId(this.openKeys, this.projectDivisionData, 0)
        },
        getAllNodeId (expandedKeys, moduleDataList, level) {
            if(level>1){
                return expandedKeys
            }
            for (let i = 0; i < moduleDataList.length; i++) {
                expandedKeys.push(moduleDataList[i].value)
                if (moduleDataList[i].children) {
                    expandedKeys = this.getAllNodeId(expandedKeys, moduleDataList[i].children, level+1)
                }
            }
            return expandedKeys
        },
        getListData() {
            this.loading = true;
            this.selectData = [];
            this.tableData = []
            this.pagedData = []
            getListData(this.list_url, this.search_Obj).then(res => {
                this.loading = false;
                this.tableData = []
                if (res.code === 1) {
                    this.tableData = res.data.list;
                    this.tableData.sort((a, b) => {
                        let a1 = a[this.sortData.prop].toString()
                        let b1 = b[this.sortData.prop].toString()
                        return b1.localeCompare(a1);
                    });
                    this.total = res.data.list.length
                    this.handleCurrentChange(1)
                    this.grade = res.data.grade
                    this.pid = res.data.pid
                    this.pname = res.data.pname
                    setTimeout(() => {
                        this.$refs["my-tree"].setCurrentKey(this.pid);
                    }, 1000);
                }else if(res.code == 990){
                    this.empty_text = res.msg
                    this.grade = res.data.grade
                    this.pid = res.data.pid
                    this.pname = res.data.pname
                    this.total = 0
                }
            })
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            const startIndex = (this.currentPage - 1) * this.pageSize;
            const endIndex = startIndex + this.pageSize;
            this.pagedData = this.tableData.slice(startIndex, endIndex);
        },
        sortTable(column) {
            console.log(column)
            this.tableData.sort((a, b) => {
                if (column.order === 'ascending') {
                    let a1 = a[column.prop].toString()
                    let b1 = b[column.prop].toString()
                    return a1.localeCompare(b1);
                } else {
                    let a1 = a[column.prop].toString()
                    let b1 = b[column.prop].toString()
                    return b1.localeCompare(a1);
                }
            });
            this.handleCurrentChange(this.currentPage)
        },
        clickPrjectDivision(data){
            this.pid = data.id
            this.search_Obj.pid = data.id
            this.current = 1
            this.getListData()
            this.list_model = 1
        },
        info(index, row) {
            this.list_model = 2
            this.hole_id = row.hole_id
            verifyCheck(row.hole_id, this.search_Obj.report_type, this.search_Obj.is_error).then(res=>{
                if(res.code == 1){
                    this.tableData1 = res.data.list
                    this.work_hole = res.data.work_hole
                }
            })
        },
        info1(row){
            this.hole_id = row.hole_id
            this.segment_no = row.segment_no
            this.infoshow = true
        },
        verifyOk(){
            this.infoshow = false
            this.list_model = 2
            verifyCheck(this.hole_id, this.search_Obj.report_type, this.search_Obj.is_error).then(res=>{
                if(res.code == 1){
                    this.tableData1 = res.data.list
                    this.work_hole = res.data.work_hole
                }
            })
        },
        back(){
            this.list_model = 1
            this.tableData1 = []
            this.work_hole = {}
            this.getListData()
        },
        export(){
            verifyExportUnit(this.search_Obj.report_type, this.pid, this.search_Obj.f_hole_code, this.search_Obj.is_error).then(res=>{
                if(res.code == 1){
                    window.open(res.data)
                }else{
                    this.$msg(res.msg)
                }
            })
        },
        exportExcel(){
            this.export_type = 1;
            this.export_show = true
        },
        exportPDF(){
            this.export_type = 2;
            this.export_show = true
        },
        doExport(){
            if(this.export_time_type == 0){
                this.start_date = ''
                this.end_date = ''
            }else if(this.export_time_type == 1 && (this.start_date == '' || this.end_date == '')){
                this.$msg("请先选择时间区间")
                return
            }
            if(this.export_type ==1){
                this.export_show = false
                exportVerifyExcel(this.pid, this.grade, this.search_Obj.report_type, this.start_date, this.end_date).then(res=>{
                    if(res.code == 1){
                        window.open(res.data)
                    }else{
                        this.$msg(res.msg)
                    }
                })
            }else{
                if(this.grade !=4){
                    this.$msg("请选择左侧单元")
                    return
                }
                let confirm_msg = "确定要批量导出单元【"+this.pname+"】下的PDF数据吗？"
                this.$confirm(confirm_msg, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.export_show = false
                    const loading = this.$loading({
                        lock: true,
                        text: '正在导出，该过程用时较长，请耐心等待...',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                    exportVerifyReportPDFByUnit(this.pid, this.search_Obj.report_type, this.start_date, this.end_date).then(res=>{
                        loading.close()
                        if(res.code == 1){
                            window.open(res.data)
                        }else{
                            this.$msg(res.msg)
                        }
                    })
                }).catch(() => { })
            }
        },
        exportHole(){
            verifyExportHole(this.search_Obj.report_type, this.hole_id).then(res=>{
                if(res.code == 1){
                    window.open(res.data)
                }else{
                    this.$msg(res.msg)
                }
            })
        },
        dateRangeSet(val){
            if(this.$isNotNull(val)){
                this.start_date = val[0]
                this.end_date = val[1]
            }else{
                this.start_date = ''
                this.end_date = ''
            }
        },
    }
};
</script>
<style lang="less" scoped>
    .el-table /deep/ .el-table__cell {
        padding: 10px 0;
    }
    .el-card /deep/ .el-card__header {
        padding: 10px 20px;
    }
</style>